import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';
const warningsToIgnore = [
    'Redirected when going from',
    'Avoided redundant navigation',
    'ResizeObserver loop completed with undelivered notifications.',
    'app-offline',
];
function initBugsnag(user) {
    const apiKey = process.env.VUE_APP_BUGSNAG_API_KEY;
    if (!apiKey) {
        console.warn('[Bugsnag] VUE_APP_BUGSNAG_API_KEY is not set, skipping initialization.');
        return;
    }
    Bugsnag.start({
        apiKey,
        appVersion: process.env.VUE_APP_VERSION || 'unknown',
        releaseStage: process.env.VUE_APP_DEPLOY_TYPE || process.env.NODE_ENV,
        plugins: [new BugsnagPluginVue()],
        onError(event) {
            if (user) {
                event.setUser(user.id);
                event.addMetadata('user', {
                    role: user.role_name,
                    account_id: user.account_id,
                    account_kind: user.account_kind,
                });
            }
            if ('originalError' in event && 'isAxiosError' in event.originalError && event.originalError.isAxiosError) {
                return false;
            }
            if ('originalError' in event && 'message' in event.originalError && warningsToIgnore.some(item => event.originalError.message.includes(item))) {
                return false;
            }
            return true;
        },
    });
    const bugsnagVue = Bugsnag.getPlugin('vue');
    if (bugsnagVue) {
        bugsnagVue.installVueErrorHandler(Vue);
    }
}
export { initBugsnag, };
